module.exports = __webpack_public_path__ + "static/media/pepper-hot.e2c89f97.svg";